export default __webpack_public_path__ + "static/media/Mask Group 49.07732754.png";